(function () {
  if (customElements.get('ce-drop-down-placer') !== undefined) {
    return;
  }

  class DropDownPlacer extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        root: '[data-drop-down-placer-root]',
        panel: '[data-drop-down-panel]',
      };

      this.elements = null;

      this.resizeObserver = null;
    }

    parsedCallback() {
      this.elements = {
        root: this.querySelector(this.selectors.root),
        panels: this.querySelectorAll(this.selectors.panel),
      };

      const callback = (entries) => {
        for (let entry of entries) {
          const rootRight = entry.target.getBoundingClientRect().right;

          for (let panel of this.elements.panels) {
            panel.style.left = null;

            const panelRight = panel.getBoundingClientRect().right;

            if (panelRight > rootRight) {
              const diff = panelRight - rootRight;
              panel.style.left = `-${diff}px`;
            }
          }
        }
      };

      this.resizeObserver = new ResizeObserver(callback);
      this.resizeObserver.observe(this.elements.root);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }
  }

  customElements.define('ce-drop-down-placer', DropDownPlacer);
})();
